import React from "react";
import isoimg from './Iso-Certifictate.jpg'
import "./ISOCertification.css"

function ISOCertification() {
  return (
    <div className="iso">
      <div className="isotwo">
        <p> ISO Certification</p>
        </div>
      <img src={isoimg}></img>
      
    </div>
  );
}

export default ISOCertification ;
